define('plugin/social-gallery/view/SocialGalleryIndexView',['require','lib/view/BaseCompositeView','plugin/social-gallery/view/SocialGalleryItemView','lib/view/UnwrapBehavior'],function (require) {

    var Parent = require('lib/view/BaseCompositeView');
    var SocialGalleryItemView = require('plugin/social-gallery/view/SocialGalleryItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Gallery composite view (images container)
     *
     * @class GalleryIndexView
     */
    return Parent.extend({

        _pageId: 'social_gallery',

        template: '#social_gallery_list_view',
        childView: SocialGalleryItemView,
        childViewContainer: '#sb_social_gallery_list_container',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        collectionEvents: {
            sync: 'render'
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'social_gallery'
            });
        }

    });

});
